import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import React, { ForwardedRef, forwardRef, MouseEvent, useState } from 'react';

import ActionDialog from '~components/ActionDialog';
import OberonCard from '~components/OberonCard';
import { CampaignFilter } from '~pages/CampaignManagement/CampaignDetails/useCampaignFilters/domain';

interface Props {
  filter: CampaignFilter;
  onEdit: () => void;
  onDelete: () => void;
}

const LeadAttributeFilterCard = forwardRef(({ filter, onEdit, onDelete }: Props, ref: ForwardedRef<HTMLDivElement>) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [deleteConfirmModalOpen, setDeleteConfirmModalOpen] = useState<boolean>(false);

  const handleMenuOpen = (e: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(e.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleDeleteConfirmationOpen = () => {
    setAnchorEl(null);
    setDeleteConfirmModalOpen(true);
  };

  const handleDeleteConfirmationClose = () => {
    setDeleteConfirmModalOpen(false);
  };

  const handleEdit = () => {
    setAnchorEl(null);
    onEdit();
  };

  const handleDelete = () => {
    onDelete();
    setDeleteConfirmModalOpen(false);
  };

  return (
    <>
      <OberonCard
        titleFontWeight={700}
        title={filter.name}
        subHeader={
          <>
            <Box
              sx={{
                width: '100%',
                minWidth: '100%',
                maxWidth: 0,
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
              }}>
              <b>Lead Field:</b> {filter.field}
            </Box>
            <Box
              title={filter.match}
              sx={{
                width: '100%',
                minWidth: '100%',
                maxWidth: 0,
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
              }}>
              <b>Pattern:</b> {filter.match}
            </Box>
          </>
        }
        action={
          <>
            <IconButton aria-controls='simple-menu' aria-haspopup='true' onClick={handleMenuOpen}>
              <MoreHorizIcon />
            </IconButton>
            <Menu id='simple-menu' anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleMenuClose}>
              <MenuItem onClick={handleEdit}>Edit</MenuItem>
              <MenuItem onClick={handleDeleteConfirmationOpen}>Delete</MenuItem>
            </Menu>
          </>
        }
      />

      <ActionDialog
        open={deleteConfirmModalOpen}
        title='Are you sure you want to do this?'
        content={`You are about to delete the ${filter.name} filter, once you have completed this action it cannot be undone.`}
        onClose={handleDeleteConfirmationClose}
        onAccept={handleDelete}
        primaryActionTitle='Delete'
      />
    </>
  );
});

export default LeadAttributeFilterCard;
